import React, { Fragment, ChangeEvent, useEffect } from 'react';
import { FieldProps, FieldArray } from 'formik';
import { Text, Checkbox, Box } from '@bechtel/gds';
import { materialStatusList } from './types';
import { SubHeader, LabelStyled } from '../styled';
import { Trans } from '@lingui/macro';

export const MaterialStatus: React.FC<FieldProps> = ({ form }) => {
  useEffect(() => {
    if (materialStatusList) form.setFieldValue('materialStatusCount', materialStatusList.length);
    else form.setFieldValue('materialStatusCount', 0);
  }, []);
  return (
    <Fragment>
      <Box data-testid="success" flexDirection={{ sm: 'column' }}>
        <FieldArray name="materialStatus">
          {({ remove, push }) => {
            const onChangeFn = (e: ChangeEvent<HTMLInputElement>) => {
              const value = e.target.value;
              if (form.values.materialStatus.includes(value)) {
                const index = form.values.materialStatus.findIndex((entity: string) => {
                  return entity === value;
                });
                remove(index);
              } else {
                push(value);
              }
            };
            return (
              <Fragment>
                <SubHeader>
                  <Box>
                    <Box mr={{ sm: '600' }}>
                      <Checkbox
                        type="checkbox"
                        checked={form.values.materialStatus.length === materialStatusList.length}
                        onChange={(e: ChangeEvent<HTMLInputElement>) =>
                          e.target.checked
                            ? form.setFieldValue(
                                'materialStatus',
                                materialStatusList.map((entity) => {
                                  return entity.label;
                                })
                              )
                            : form.setFieldValue('materialStatus', [])
                        }
                      />
                    </Box>
                    <Text color="grey.1000" size="400" weight="600">
                      <Trans>Material Status</Trans>
                    </Text>
                  </Box>
                  {form.values.materialStatus.length > 0 && (
                    <Text color="grey.1000" size="400">
                      {form.values.materialStatus.length} <Trans>Selected</Trans>
                    </Text>
                  )}
                </SubHeader>
                {materialStatusList.map(({ id, label }, index) => {
                  return (
                    <LabelStyled key={index} data-testid={`backlog-filter-material-status-${id}`}>
                      <Box mr={{ sm: '600' }}>
                        <Checkbox
                          value={label}
                          type="checkbox"
                          onChange={onChangeFn}
                          checked={form.values.materialStatus.includes(label)}
                        />
                      </Box>
                      <Text color="grey.1000" size="400">
                        {label}
                      </Text>
                    </LabelStyled>
                  );
                })}
              </Fragment>
            );
          }}
        </FieldArray>
      </Box>
    </Fragment>
  );
};
